// extracted by mini-css-extract-plugin
module.exports = {"heading":"_badad7","pagination":"_354b0b","root":"_3cff5a"};